<template>
  <div class="Three3Charts">
    <!-- style="min-width:40px;height:40px" -->
    <div class="echarts" :id="chartid"></div>
    <div class="bg" v-if="background"></div>
  </div>
</template>
<script>
import HighCharts from 'highcharts'; //为防止报错在页面上再次引入Highcharts
// 引用所需外部资源
import Highcharts3d from 'highcharts/highcharts-3d';
import { getFilterValue } from '../../../utils/tool';
import { request } from '../../../common/request';

// 注册所需外部资源
Highcharts3d(HighCharts);

export default {
  name: 'Three3Charts',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      chartid: '',
      background: true,
      peiData: [],
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  // created() {
  //   clearInterval(this.apiIntervalTaskID);
  //   clearInterval(this.staticIntervalTaskID);
  //   clearInterval(this.staticIntervalTaskID2);
  //   this.registerDebounceAndThrottle();
  // },
  mounted() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();

    this.chartid = this.Configuration.id;
    this.setOptonHeight();
    const that = this;
    window.onresize = function() {
      that.setOptonHeight();
    };
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    // this.getApiDataResByFilterAndResponseQuery();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    setOptonHeight() {
      // 修改3d饼图绘制过程
      const each = HighCharts.each;
      const round = Math.round;
      const cos = Math.cos;
      const sin = Math.sin;
      const deg2rad = Math.deg2rad;
      HighCharts.wrap(HighCharts.seriesTypes.pie.prototype, 'translate', function(proceed) {
        proceed.apply(this, [].slice.call(arguments, 1));
        // Do not do this if the chart is not 3D
        if (!this.chart.is3d()) {
          return;
        }
        const series = this;
        const chart = series.chart;
        const options = chart.options;
        const seriesOptions = series.options;
        const depth = seriesOptions.depth || 0;
        const options3d = options.chart.options3d;
        const alpha = options3d.alpha;
        const beta = options3d.beta;
        var z = seriesOptions.stacking ? (seriesOptions.stack || 0) * depth : series._i * depth;
        z += depth / 2;
        if (seriesOptions.grouping !== false) {
          z = 0;
        }
        each(series.data, function(point) {
          const shapeArgs = point.shapeArgs;
          var angle;
          point.shapeType = 'arc3d';
          var ran = point.options.h;
          shapeArgs.z = z;
          shapeArgs.depth = depth * 0.75 + ran;
          shapeArgs.alpha = alpha;
          shapeArgs.beta = beta;
          shapeArgs.center = series.center;
          shapeArgs.ran = ran;
          angle = (shapeArgs.end + shapeArgs.start) / 2;
          point.slicedTranslation = {
            translateX: round(cos(angle) * seriesOptions.slicedOffset * cos(alpha * deg2rad)),
            translateY: round(sin(angle) * seriesOptions.slicedOffset * cos(alpha * deg2rad)),
          };
        });
      });
      (function(H) {
        H.wrap(HighCharts.SVGRenderer.prototype, 'arc3dPath', function(proceed) {
          // Run original proceed method
          const ret = proceed.apply(this, [].slice.call(arguments, 1));
          ret.zTop = (ret.zOut + 0.5) / 100;
          return ret;
        });
      })(HighCharts);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let highWH = {};
      let color = [];
      let source = [];
      let seriesList = [];
      let bg = '';
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        color = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        color = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      if (this.Configuration.propertyData.ChartBackground?.value) {
        bg = this.Configuration.propertyData.ChartBackground.value;
      }
      this.background = bg;

      let xAxis_data = [];
      let series = [];
      let unie = '';
      let xyData = [];
      let id = this.chartid;
      function DealData() {
        seriesList.forEach((s, y, index) => {
          source.forEach((item, index) => {
            if (s === item.s) {
              unie = item.s;
              // h 是高度  y是占的圆环长度
              xyData.push({
                name: item.x,
                y: parseInt(item.y),
                h: parseInt(item.y),
              });
            }
          });

          let highcharts = new HighCharts.Chart(id, {
            chart: {
              type: 'pie',
              backgroundColor: 'rgba(0,0,0,0)',
              renderTo: 'container',
              options3d: {
                enabled: true,
                alpha: 75,
                beta: 0, //图表视图旋转角度
              },
              events: {
                load: function() {
                  var each = HighCharts.each,
                    points = this.series[0].points;
                  each(points, function(p) {
                    p.graphic.attr({
                      translateY: -p.shapeArgs.ran,
                    });
                    p.graphic.side1.attr({
                      translateY: -p.shapeArgs.ran,
                    });
                    p.graphic.side2.attr({
                      translateY: -p.shapeArgs.ran,
                    });
                  });
                },
              },
            },
            exporting: { enabled: false }, //隐藏导出
            title: {
              show: 'false',
              text: null,
            },
            subtitle: {
              text: null,
            },
            credits: {
              enabled: false,
            },
            tooltip: {
              // 显示框 值的
              valuePrefix: '', // 前缀
              valueSuffix: '%', // 后缀
            },
            plotOptions: {
              pie: {
                cursor: 'pointer',
                // 每块厚度
                innerSize: '80%',
                center: ['50%', '77%'],
                dataLabels: {
                  // 设置显示文字数值
                  enabled: true,
                  formatter: function() {
                    return this.point.name + '<br><p style="color:' + this.color + '">' + this.y + '%';
                  },
                },
                dataLabels: {
                  enabled: true,
                  style: {
                    fontSize: fontStyle.xAxisSize + 'px', //这个是改饼状图里面显示的字体
                  },
                },
                // 显示图例
                showInLegend: false,
              },
            },

            series: [
              {
                type: 'pie',
                name: '',
                colorByPoint: true,
                colors: color,
                data: xyData,
              },
            ],
          });
          series.push(highcharts);
          // 防止图表上下颠倒
          HighCharts.addEvent(highcharts, 'redraw', function() {
            var each = HighCharts.each,
              points = highcharts.series[0].points;
            each(points, function(p, i) {
              // if (i !== 1 && i !== 2) {
              p.graphic.attr({
                translateY: -p.shapeArgs.ran,
              });
              p.graphic.side1.attr({
                translateY: -p.shapeArgs.ran,
              });
              p.graphic.side2.attr({
                translateY: -p.shapeArgs.ran,
              });
            });
          });
        });
        xAxis_data = [...new Set(xAxis_data)];
      }
      DealData();
      this.peiData = xyData;

      // 关闭加载
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          this.setEchartsOptions(data);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          // this.loading.close();
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        // this.loading.close();
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let params = ChartsData.apiData.apiPostParams || '{}';
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   params: eval('(' + params + ')'),
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || '{}';
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: eval('(' + params + ')'),
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            data: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function(data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
  Configuration: {
    componentTitle: '3D环形图',
    componentName: 'Three3Charts',
    componentOverViewImg: './img/charts/ThreeCharts/Three3Charts.png',
    id: '',
    style: {
      width: 250,
      height: 100,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: ['#FF8700', '#ffc300', '#00e473', '#009DFF', '#0034ff'],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['个'],
            source: [
              {
                s: '个',
                x: '苹果',
                y: 16,
                i: 1,
              },
              {
                s: '个',
                x: '香蕉',
                y: 27,
                i: 2,
              },
              {
                s: '个',
                x: '梨',
                y: 54,
                i: 3,
              },
              {
                s: '个',
                x: '百香果',
                y: 42,
                i: 4,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 423,
          height: 264,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          top: '17%',
          bottom: '57%',
          left: '15%',
          right: '15%',
        },
      },
      highchartsSize: {
        title1: '宽度',
        title2: '高度',
        propertyComponentName: 'HighchartsSizeConfiger',
        value: {
          width: 100,
          height: 45,
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      ChartBackground: {
        propertyComponentName: 'ChartBackgroundConfiger',
        value: true,
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.Three3Charts {
  width: 100%;
  height: 100%;
  .echarts {
    width: 100%;
    height: 100%;
  }
  .bg {
    z-index: -1;
    width: 100%;
    height: 60%;
    margin-top: -130px;
    position: absolute;
    background: url('../../../assets/img/threechartsBt.png') no-repeat center;
    background-size: 100% 100%;
  }
}
</style>
